import React from "react";
import { Modal, Button } from "antd";
import "./deleteModal.scss";

export default function DeleteModal({
  openModal,
  message,
  subMessage,
  yesClick,
  closeModal,
}) {
  return (
    <Modal
      className="delete-modal"
      onCancel={closeModal}
      open={openModal}
      footer={false}
    >
      <div className="modal-message">{message}</div>
      <p>{subMessage}</p>
      <div className="yes-no-btn">
        <Button onClick={yesClick} className="yes-btn">
          Yes
        </Button>
        <Button onClick={closeModal} className="no-btn">
          No
        </Button>
      </div>
    </Modal>
  );
}
